import flatpickr from "flatpickr"

const DatePicker = () => {
	const dates = document.querySelectorAll('.date-input');
	const times = document.querySelectorAll('.time-input');
	dates.forEach((el) => {
		new flatpickr(el, {
		});
	})

	times.forEach((el) => {
		new flatpickr(el, {
			enableTime: true,
			noCalendar: true,
			dateFormat: "H:i",
		});
	})

}
export default DatePicker;